import { render, staticRenderFns } from "./MediaSourcePlaceholder.vue?vue&type=template&id=36d522c7&lang=pug&"
import script from "./MediaSourcePlaceholder.vue?vue&type=script&lang=js&"
export * from "./MediaSourcePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports